import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserShield, FaArrowLeft } from 'react-icons/fa';
import { adminLogin } from '../services/AdminAuthService';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // Simulate delay for UX
    await new Promise(r => setTimeout(r, 600));
    const result = adminLogin(email, password);
    if (result.success) {
      navigate('/admin');
    } else {
      setError('Invalid admin credentials');
    }
    setLoading(false);
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <FaUserShield />
        </div>
        <h2>Admin Login</h2>
        <p>Sign in to manage orders</p>

        {error && <div className="admin-login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@example.com"
              className={error ? 'error' : ''}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              className={error ? 'error' : ''}
              required
            />
          </div>
          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <a href="/" className="admin-login-back">
          <FaArrowLeft style={{ marginRight: 6, fontSize: 11 }} />Back to website
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
